import { render } from "./SettingsTab.vue?vue&type=template&id=0034a34d&scoped=true"
import script from "./SettingsTab.vue?vue&type=script&lang=js"
export * from "./SettingsTab.vue?vue&type=script&lang=js"

import "./SettingsTab.vue?vue&type=style&index=0&id=0034a34d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0034a34d"]])

export default __exports__